import { render, staticRenderFns } from "./InvestmentHistoryMobile.vue?vue&type=template&id=a3ec3bd6"
import script from "./InvestmentHistoryMobile.vue?vue&type=script&lang=js"
export * from "./InvestmentHistoryMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports